import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Config from "./../config.json";

export const cropsPestApi = createApi({
  reducerPath: "cropsPestApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${Config.IPM_SERVER_URL}/api/cropsPests/`,
    credentials: "include",
    headers: {
      "X-API-Key": Config.X_API_KEY,
    },
  }),
  endpoints: (builder) => ({
    getCropsPests: builder.query({
      query: () => ({
        url: "getAll",
        params: {},
        method: "GET",
      }),
    }),
    createCropPest: builder.mutation({
      query: (comment) => ({
        url: "create",
        body: comment,
        method: "POST",
      }),
    }),
    deleteCropPest: builder.mutation({
      query: (id) => ({
        url: `DeletePest/${id}`,
        body: id,
        method: "DELETE",
      }),
    }),
  }),
});

export const { useCreateCropsPestMutation, useDeleteCropPestMutation } =
  cropsPestApi;
